import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cpf - CPF do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cpf) {
  try {
    const { data } = await Vue.prototype.$api.post(
      '/app/cadastros-individuais',
      {
        co_ibge: cod_ibge,
        cpf: nu_cpf,
      }
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/cadastros-individuais/detalhado/todos/equipe/' +
        cod_ibge +
        '/' +
        nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/cadastros-individuais/detalhado/microarea/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}
// Buscar última atualização dos dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getUltimaAtualizacao(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/ultima-atualizacao-dos-dados/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'green-color'
  } else {
    return 'red-color'
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(data_secretaria_de_saude, item) {
  if (
    item.dias_fci_atualizada == null ||
    item.dias_fci_atualizada > 730 ||
    item.dias_fcdt_atualizada == null ||
    item.dias_fcdt_atualizada > 730
  ) {
    return 'red'
  }

  if (
    (item.dias_fci_atualizada != null &&
      item.dias_fci_atualizada > 365 &&
      item.dias_fci_atualizada < 730) ||
    (item.dias_fcdt_atualizada != null &&
      item.dias_fcdt_atualizada > 365 &&
      item.dias_fcdt_atualizada < 730)
  ) {
    return 'orange'
  }

  if (
    item.dias_fci_atualizada != null &&
    item.dias_fci_atualizada < 730 &&
    item.dias_fcdt_atualizada != null &&
    item.dias_fcdt_atualizada < 730
  ) {
    return 'green'
  }
}

export function generatePdf(
  cadastros,
  selectEquipe,
  micro_area,
  data_secretaria_de_saude
) {
  let title_pdf = 'Cadastros cidadãos'
  let titlePdfSave = utils.methods.titlePdf('Cadastros cidadãos')

  let description_pdf = 'Cadastro populacional feito pela eSF e/ou eAP'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'CI',
    'CDT',
    'CAMPOS CI',
    'CAMPOS CDT',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    let dt_nascimento = `${utils.methods.formatDate(
      cadastros[i].dt_nascimento
    )}\n(${cadastros[i].idade} ${cadastros[i].idade > 1 ? ' anos' : ' ano'})`
    obj.dt_nascimento = dt_nascimento

    obj.no_mae = cadastros[i].no_mae
    let fci = `${
      cadastros[i].dt_ultima_ficha != null
        ? utils.methods.formatDate(cadastros[i].dt_ultima_ficha)
        : ''
    }\n(${verificaTempo(
      cadastros[i].dt_ultima_ficha,
      data_secretaria_de_saude
    )} ${
      cadastros[i].percent_fci_completa
        ? cadastros[i].percent_fci_completa + '%'
        : '0%'
    })`
    obj.fci = cadastros[i].dt_ultima_ficha != null ? fci : ''

    let fcdt = `${
      cadastros[i].dt_ultima_fcd != null
        ? utils.methods.formatDate(cadastros[i].dt_ultima_fcd)
        : ''
    }\n(${verificaTempo(
      cadastros[i].dt_ultima_fcd,
      data_secretaria_de_saude
    )} ${cadastros[i].percent_fcdt_completa}%)`
    obj.fcdt = cadastros[i].dt_ultima_fcd != null ? fcdt : ''

    obj.campos_fci = ''
    if (cadastros[i].fci_completa == null) {
      obj.campos_fci =
        'Após o preenchimento da ficha simplificada do cidadão,recomenda-se preencher também a Ficha de Cadastro Individual (FCI) completa. Isso garante a qualidade, completude e integridade do cadastro.'
    } else if (parseInt(cadastros[i].percent_fci_completa) >= 100) {
      obj.campos_fci = 'Parabéns CI completo.'
    } else {
      obj.campos_fci = cadastros[i].fci_completa.replace(/^\[|\]$/g, '')
    }

    obj.campos_fcdt = ''
    if (cadastros[i].fcdt_completa == null) {
      obj.campos_fci =
        'Após o preenchimento da ficha simplificada do cidadão, recomenda-se preencher também o Cadastro Domiciliar e Territorial (CDT) completo. Isso garante a qualidade, completude e integridade do cadastro.'
    } else if (parseInt(cadastros[i].percent_fcdt_completa) >= 100) {
      obj.campos_fcdt = 'Parabéns CDT completo.'
    } else {
      obj.campos_fcdt = cadastros[i].fcdt_completa.replace(/^\[|\]$/g, '')
    }

    obj.dias_fci_atualizada = cadastros[i].dias_fci_atualizada
    obj.dias_fcdt_atualizada = cadastros[i].dias_fcdt_atualizada
    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Total',
            value: cadastros.length,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }

          if (data.row.section !== 'head') {
            let item = {
              dias_fci_atualizada: data.row.raw[7],
              dias_fcdt_atualizada: data.row.raw[8],
            }
            let color = printTableRow(data_secretaria_de_saude, item)
            if (color == 'red') {
              doc.setTextColor(194, 10, 16)
            }
            if (color == 'orange') {
              doc.setTextColor(245, 167, 66)
            }
            if (color == 'green') {
              doc.setTextColor(2, 99, 57)
            }
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

function verificaTempo(value, data_secretaria_de_saude) {
  if (value != null) {
    let dias = utils.methods.differenceOfDaysBetweenTwoDates(
      value,
      data_secretaria_de_saude.split('/').reverse().join('-')
    )
    if (dias <= 31) {
      return dias + ' dias'
    } else {
      let meses = Math.floor(dias / 30)
      return meses == 1 ? `${meses} mês` : `${meses} meses`
    }
  } else {
    return ''
  }
}

export function getRadius(item) {
  let population = item.denominador
  const minRadius = 10
  const maxRadius = 100
  const minPopulation = 0
  const maxPopulation = 10000

  // Ensure that the population is within bounds
  if (population < minPopulation) population = minPopulation
  if (population > maxPopulation) population = maxPopulation

  // Calculate the radius using linear interpolation
  let radius =
    minRadius +
    ((population - minPopulation) / (maxPopulation - minPopulation)) *
      (maxRadius - minRadius)
  return radius
}

export function getRadiusColor(item) {
  let denominador = Number(item.denominador)
  let cadSisab = Number(item.cad_sisab)
  let minCad = Number(item.min_cad)
  let maxCad = Number(item.max_cad)

  if (denominador < minCad) {
    return 'orange'
  } else if (denominador >= minCad && denominador <= maxCad) {
    return 'green'
  } else {
    return 'red'
  }
}

export function getRowColorTabelaMapa(item) {
  if (Number(item.denominador) < Number(item.min_cad)) {
    return 'orange'
  } else if (
    Number(item.denominador) >= Number(item.min_cad) &&
    Number(item.denominador) <= Number(item.max_cad)
  ) {
    return 'green'
  } else {
    return 'red'
  }
}

export function resultadoDoMunicipio(
  indicadorResultado,
  tabelaResultado,
  parametro
) {
  let total = 0
  let atualizados = 0
  let desatualizados = 0
  let resultado_no_municipio = 0

  let dadosDoMunicipio = ''
  if (indicadorResultado !== null) {
    dadosDoMunicipio = tabelaResultado.find((item) => {
      return (
        item.ibge_ine === 'MUN' && item.indicador == indicadorResultado.value
      )
    })
  } else {
    dadosDoMunicipio = tabelaResultado.find((item) => {
      return item.ibge_ine === 'MUN' && item.indicador == '32'
    })
  }

  if (dadosDoMunicipio === undefined) {
    return {
      total: 0,
      atualizados: 0,
      desatualizados: 0,
      resultado: 0,
    }
  }

  let denomidador = dadosDoMunicipio ? dadosDoMunicipio.denominador : 0
  let resultado = dadosDoMunicipio ? dadosDoMunicipio?.resultado : 0

  total = denomidador !== null ? parseInt(denomidador) : 0

  atualizados = resultado !== null ? parseInt(resultado) : 0
  desatualizados = 100 - parseInt(atualizados)

  resultado_no_municipio = Math.round((total / parametro) * 100)

  return {
    total: total,
    atualizados: atualizados,
    desatualizados: desatualizados,
    resultado: resultado_no_municipio,
  }
}

export function resultadoClassificacaoMunicipio(
  indicadorResultado,
  tabelaResultado
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDoMunicipio = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === 'MUN' && item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDoMunicipio === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDoMunicipio.dados)
    if (indicadorResultado.value == 'por-cadastro-esus' && dados.nivel == 1) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_cad0_75: dados.qtd_cad0_75,
        qtd_cad1_5: dados.qtd_cad1_5,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function resultadoDaEquipe(
  indicadorResultado,
  tabelaResultado,
  equipeDataNuIne,
  parametro
) {
  let total = 0
  let atualizados = 0
  let desatualizados = 0
  let resultadoNaEquipe = 0

  if (equipeDataNuIne == null || equipeDataNuIne == '') {
    return {
      total: 0,
      atualizados: 0,
      desatualizados: 0,
      resultado: 0,
    }
  }

  let dadosDaEquipe = ''
  if (indicadorResultado !== null) {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return (
        item.ibge_ine === equipeDataNuIne &&
        item.indicador == indicadorResultado.value
      )
    })
  } else {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return item.ibge_ine === equipeDataNuIne && item.indicador == '32'
    })
  }

  if (dadosDaEquipe === undefined) {
    return {
      total: 0,
      atualizados: 0,
      desatualizados: 0,
      resultado: 0,
    }
  }

  let denomidador = dadosDaEquipe ? dadosDaEquipe.denominador : 0
  let resultado = dadosDaEquipe ? dadosDaEquipe?.resultado : 0

  total = denomidador !== null ? parseInt(denomidador) : 0

  atualizados = resultado !== null ? parseInt(resultado) : 0
  desatualizados = 100 - parseInt(atualizados)

  resultadoNaEquipe = Math.round((total / parametro) * 100)

  return {
    total: total,
    atualizados: atualizados,
    desatualizados: desatualizados,
    resultado: resultadoNaEquipe,
  }
}

export function resultadoClassificacaoEquipe(
  indicadorResultado,
  tabelaResultado,
  nu_ine
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaEquipe = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === nu_ine && item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDaEquipe === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaEquipe.dados)
    if (indicadorResultado.value == 'por-cadastro-esus' && dados.nivel == 2) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_cad0_75: dados.qtd_cad0_75,
        qtd_cad1_5: dados.qtd_cad1_5,
      }
    }
    if (indicadorResultado.value == 'por-parametro' && dados.nivel == 2) {
      resultado = dados.result_param_cad
      escore = dados.escore_param
      classificacao = dados.classificacao_param
      dadosFormula = {
        tipo: 'por-parametro',
        parametro: dados.cad_param,
        qtd_cad0_75: dados.qtd_cad0_75,
        qtd_cad1_5: dados.qtd_cad1_5,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function resultadoDaMicroArea(
  indicadorResultado,
  tabelaResultado,
  micro_area,
  parametro
) {
  let total = 0
  let atualizados = 0
  let desatualizados = 0
  let resultadoNaMicroArea = 0

  let dadosDaEquipe = ''
  if (indicadorResultado !== null) {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return (
        item.ibge_ine === micro_area &&
        item.indicador == indicadorResultado.value
      )
    })
  } else {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return item.ibge_ine === micro_area && item.indicador == '32'
    })
  }

  if (dadosDaEquipe === undefined) {
    return {
      total: 0,
      atualizados: 0,
      desatualizados: 0,
      resultado: 0,
    }
  }

  let denomidador = dadosDaEquipe ? dadosDaEquipe.denominador : 0
  let resultado = dadosDaEquipe ? dadosDaEquipe?.resultado : 0

  total = denomidador !== null ? parseInt(denomidador) : 0

  atualizados = resultado !== null ? parseInt(resultado) : 0
  desatualizados = 100 - parseInt(atualizados)

  resultadoNaMicroArea = Math.round((total / parametro) * 100)

  return {
    total: total,
    atualizados: atualizados,
    desatualizados: desatualizados,
    resultado: resultadoNaMicroArea,
  }
}

export function resultadoClassificacaoMicroArea(
  indicadorResultado,
  tabelaResultado,
  micro_area
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaMicroArea = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === micro_area &&
      item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDaMicroArea === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaMicroArea.dados)
    if (indicadorResultado.value == 'por-cadastro-esus' && dados.nivel == 3) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_cad0_75: dados.qtd_cad0_75,
        qtd_cad1_5: dados.qtd_cad1_5,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function resultadoDoAcs(
  indicadorResultado,
  tabelaResultado,
  profissional,
  parametro
) {
  let total = 0
  let atualizados = 0
  let desatualizados = 0
  let resultadoNoAcs = 0

  let dadosDaEquipe = ''
  if (indicadorResultado !== null) {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return (
        item.ibge_ine === profissional &&
        item.indicador == indicadorResultado.value
      )
    })
  } else {
    dadosDaEquipe = tabelaResultado.find((item) => {
      return item.ibge_ine === profissional && item.indicador == '28'
    })
  }

  if (dadosDaEquipe === undefined) {
    return {
      total: 0,
      atualizados: 0,
      desatualizados: 0,
      resultado: 0,
    }
  }

  let denomidador = dadosDaEquipe ? dadosDaEquipe.denominador : 0
  let resultado = dadosDaEquipe ? dadosDaEquipe?.resultado : 0

  total = denomidador !== null ? parseInt(denomidador) : 0

  atualizados = resultado !== null ? parseInt(resultado) : 0
  desatualizados = 100 - parseInt(atualizados)

  resultadoNoAcs = Math.round((total / parametro) * 100)

  return {
    total: total,
    atualizados: atualizados,
    desatualizados: desatualizados,
    resultado: resultadoNoAcs,
  }
}

export function serieHistoricaMunicipio(dadosSerieHistorica, indicador) {
  let dataItens = dadosSerieHistorica
  if (indicador !== null) {
    dataItens = dataItens.filter((item) => {
      return item.indicador == indicador.value && item.ibge_ine === 'MUN'
    })
  }
  let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
  let array_chart_municipio = []
  let array_xaxis = []
  //carregar eixo x
  for (let i = 0; i < dataItens12meses.length; i++) {
    array_xaxis.push(dataItens12meses[i].mes_ano)
  }
  // carregar dados do município
  for (let i = 0; i < dataItens12meses.length; i++) {
    array_chart_municipio.push(dataItens12meses[i].resultado)
  }
  return {
    array_xaxis: array_xaxis,
    array_chart_municipio: array_chart_municipio,
    data_dados_chart:
      dataItens12meses.length > 0
        ? utils.methods.formatDate(dataItens12meses[0].data_dados)
        : '',
  }
}

export function serieHistoricaEquipe(
  xaxis,
  dadosSerieHistorica,
  indicadorGrafico,
  nu_ine
) {
  let array_chart_equipe = []
  for (let i = 0; i < xaxis.length; i++) {
    var eixo_x_atual = xaxis[i]
    let dataItens = dadosSerieHistorica
    if (indicadorGrafico !== null) {
      dataItens = dataItens.filter((item) => {
        return (
          item.indicador == indicadorGrafico.value && item.ibge_ine == nu_ine
        )
      })
    }
    let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
    for (const item of dataItens12meses) {
      var resultado = 0
      if (item.mes_ano == eixo_x_atual) {
        resultado = item.resultado
        break
      } else {
        resultado = null
      }
    }
    array_chart_equipe.push(resultado)
  }

  return {
    array_chart_equipe: array_chart_equipe,
  }
}

export function serieHistoricaMicroArea(
  xaxis,
  dadosSerieHistorica,
  indicadorGrafico,
  micro_area
) {
  let array_chart_micro_area = []
  for (let i = 0; i < xaxis.length; i++) {
    var eixo_x_atual = xaxis[i]
    let dataItens = dadosSerieHistorica
    if (indicadorGrafico !== null) {
      dataItens = dataItens.filter((item) => {
        return (
          item.indicador == indicadorGrafico.value &&
          item.ibge_ine == micro_area
        )
      })
    }
    let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
    for (const item of dataItens12meses) {
      var resultado = 0
      if (item.mes_ano == eixo_x_atual) {
        resultado = item.resultado
        break
      } else {
        resultado = null
      }
    }
    array_chart_micro_area.push(resultado)
  }

  return {
    array_chart_micro_area: array_chart_micro_area,
  }
}

export const linksAjuda = {
  pec: {
    links: [
      {
        title: 'Atualizar cadastro de cidadão',
        link: 'https://www.youtube.com/embed/oEvRQoTlUUU',
        type: 'video',
      },
      {
        title: 'Unificar cadastro de cidadão',
        link: 'https://www.youtube.com/embed/xjNISDdAQgQ',
        type: 'video',
      },
      {
        title: 'Slide',
        link: '',
        type: 'slide',
        path: 'cadastros-individuais/cad_cidadao_pec',
        slide_title: 'PEC > Cidadão',
        slides: [
          'Slide1.JPG',
          'Slide2.JPG',
          'Slide3.JPG',
          'Slide4.JPG',
          'Slide5.JPG',
          'Slide6.JPG',
          'Slide7.JPG',
          'Slide8.JPG',
          'Slide9.JPG',
        ],
      },
    ],
  },
  cds: {
    links: [
      {
        title: 'Novo cadastro individual',
        link: 'https://www.youtube.com/embed/gxfj12P_jpQ',
        type: 'video',
      },
      {
        title: 'Atualizar cadastro individual',
        link: 'https://www.youtube.com/embed/dj0dPDry-Yg',
        type: 'video',
      },
      {
        title: 'Atualizar cadastro duplicado',
        link: 'https://www.youtube.com/embed/1p9yPSrqUQY',
        type: 'video',
      },
      {
        title: 'Slide',
        link: '',
        type: 'slide',
        path: 'cadastros-individuais/cad_individual_cds',
        slide_title: 'PEC > CDS > Cadastro individual',
        slides: [
          'Slide1.JPG',
          'Slide2.JPG',
          'Slide3.JPG',
          'Slide4.JPG',
          'Slide5.JPG',
          'Slide6.JPG',
          'Slide7.JPG',
          'Slide8.JPG',
          'Slide9.JPG',
          'Slide10.JPG',
          'Slide11.JPG',
          'Slide12.JPG',
          'Slide13.JPG',
        ],
      },
    ],
  },
}
